const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon05(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    style: {
      enableBackground: "new 0 0 128 128"
    },
    viewBox: "0 0 128 128",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 50,
    style: {
      fill: "#F0652A"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M40.2,39l4.3,48.5L63.9,93l19.5-5.5L87.8,39H40.2z M78.4,54.8H55.6l0.5,6.1h21.7l-1.7,18.4L64,82.6   l0,0h-0.1l-12.2-3.4L51,69.9h5.9l0.4,4.7l6.6,1.8l6.6-1.8l0.7-7.7H50.7l-1.6-18h29.8L78.4,54.8z",
    style: {
      fill: "#FFFFFF"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon05);
export default __webpack_public_path__ + "static/media/icon05.9847d62ec5d0fab82cdb8ac4e862a960.svg";
export { ForwardRef as ReactComponent };